import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import Backend from 'i18next-http-backend'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translations
import enTranslation from './locales/en/translation.json'
import frTranslation from './locales/fr/translation.json'

// Import store to get the stored language preference
import { settingsStore } from './stores/settingsStore'

const resources = {
  en: {
    translation: enTranslation,
  },
  fr: {
    translation: frTranslation,
  },
}

i18n
  // Load translation using http (default public/locales)
  .use(Backend)
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'en',
    lng: settingsStore.language, // Use the language from the store
    debug: process.env.NODE_ENV === 'development',

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },

    // Common namespaces across components
    ns: ['translation'],
    defaultNS: 'translation',

    // React config
    react: {
      useSuspense: true,
    },
  })

// When language changes in the store, update i18n
settingsStore.setOnLanguageChange((newLanguage) => {
  i18n.changeLanguage(newLanguage)
})

export default i18n
